<div class="page-loader-overlay" *ngIf="state.loading">
  <div class="page-loader-box">

    <div class="logo-progress" [style.--progress.%]="progress">
      <img src="assets/images/logo-almamedis.png" class="logo-base" alt="AlmaMedis">

      <div class="logo-fill">
        <img src="assets/images/logo-almamedis.png" alt="AlmaMedis">
      </div>
    </div>

    <p class="loader-text">{{ state.message }}</p>

    <div *ngIf="state.error" class="loader-actions">
      <button type="button" class="btn btn-primary btn-sm" (click)="retry()">
        Reintentar
      </button>

      <button type="button" class="btn btn-link btn-sm" (click)="close()">
        Cerrar
      </button>
    </div>

  </div>
</div>